module.exports = __webpack_public_path__ + "Roboto-Medium.76cad5ba6b8a38a77fe0.eot";


//////////////////
// WEBPACK FOOTER
// /Users/vladislavlazurenko/IdeaProjects/luiziana/frontend/src/roboto-fontface/fonts/roboto/Roboto-Medium.eot
// module id = ../../../../../src/roboto-fontface/fonts/roboto/Roboto-Medium.eot
// module chunks = styles